module.exports = __webpack_public_path__ + "img/logo.f96c8003.png";